var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.education.start)+" ~ "+_vm._s(_vm.education.end))]),_c('h3',[_vm._v(_vm._s(_vm.education.school_name))]),_c('p',[_vm._v(" "+_vm._s(_vm.education.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }